import React from "react"

import WPImage, { DISPLAY_MODE } from "../_base/WPImage"
import WPCta from "../_base/WPCta"

import { ChildSelector } from "../../helpers/ChildSelector"

import * as participationStyles from "../../styles/world_championships/Participation.module.css"

const Participation = props => {
  const { content } = props

  const title = ChildSelector.select(
    content,
    `participation-title`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )
  const intro = ChildSelector.select(
    content,
    `participation-intro`,
    ChildSelector.SELECTOR_TYPE.ARRAY,
  )
  const how = ChildSelector.select(
    content,
    `participation-how`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )
  const howTo = ChildSelector.select(
    content,
    `participation-how-to`,
    ChildSelector.SELECTOR_TYPE.ARRAY,
  )
  const instIntro = ChildSelector.select(
    content,
    `participation-instructions-intro`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )
  const inst = ChildSelector.select(
    content,
    `participation-instructions`,
    ChildSelector.SELECTOR_TYPE.NODE,
  )

  return (
    <div className="container-fluid">
      <div className={`row ${participationStyles.wrapper}`}>
        <div className="col">
          <div style={{ display: "grid", gridAutoRows: "1fr" }}>
            <div
              style={{
                gridArea: "1/1",
                position: "relative",
                placeItems: "left",
                display: "grid",
                zIndex: 2,
              }}
            >
              <div className={`row g-0`}>
                <div className={`col-12 ${participationStyles.content}`}>
                  <div
                    className={`row g-0 ${participationStyles.introWrapper}`}
                  >
                    {intro.slice(0, 1).map((item, index) => (
                      <div
                        key={index}
                        className={`col-9 ${participationStyles.intro}`}
                        dangerouslySetInnerHTML={{ __html: item.innerHTML }}
                      />
                    ))}
                  </div>
                  <div className={`row g-0`}>
                    <div className={`col-12 ${participationStyles.heading}`}>
                      <h4>{title}</h4>
                    </div>
                  </div>
                  <div
                    className={`row g-0 ${participationStyles.introWrapper}`}
                  >
                    {intro.slice(1, 2).map((item, index) => (
                      <div
                        key={index}
                        className={`col-9 ${participationStyles.introHow}`}
                        dangerouslySetInnerHTML={{ __html: item.innerHTML }}
                      />
                    ))}
                  </div>

                  <div className={`row g-0 ${participationStyles.howWrapper}`}>
                    <div className={`col-9 ${participationStyles.how}`}>
                      <h1>{how}</h1>
                      {howTo.map((item, index) => (
                        <div
                          key={index}
                          className={`col-12 ${participationStyles.howTo}`}
                        >
                          {item.rawText}
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className={`row g-0 ${participationStyles.instWrapper}`}>
                    <div
                      className={`col-12 ${participationStyles.instructions}`}
                    >
                      <p>{instIntro}</p>
                      <ul>
                        {inst.childNodes.map((item, index) => (
                          <li
                            key={index}
                            className={`col-12 ${participationStyles.inst}`}
                          >
                            {item.rawText}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                  <div className={`row g-0 ${participationStyles.logoWrapper}`}>
                    <div
                      className={`col-12 col-lg-6 ${participationStyles.logo}`}
                    >
                      <WPImage
                        holder={content}
                        selector={`conference-logo`}
                        mode={DISPLAY_MODE.normal}
                        className={`${participationStyles.conferenceLogo}`}
                      />
                    </div>
                    <div
                      className={`col-12 col-lg-6 ${participationStyles.callToAction}`}
                    >
                      <WPCta
                        holder={content}
                        selector={`cta-btn`}
                        translate={false}
                        className={`${participationStyles.ctaBtn}`}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className={`${participationStyles.backgroundContainmentImage}`}
              style={{
                gridArea: "1/1",
                objectFit: "cover",
                placeItems: "left",
                zIndex: 1,
              }}
              objectfit="cover"
              placeholderstyle={{
                objectFit: `cover`,
                objectPosition: `left bottom`,
              }}
              imgstyle={{
                objectFit: `cover`,
                objectPosition: `left bottom`,
              }}
              transformoptions={{ fit: "cover" }}
            >
              <WPImage
                holder={content}
                selector={`media-asset`}
                mode={DISPLAY_MODE.normal}
                className={`d-none d-lg-block ${participationStyles.backgroundImage}`}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Participation
